export interface PermissionDependency {
  requires: string[];
}

export const PERMISSION_DEPENDENCIES: Record<string, PermissionDependency> = {
  // ─── Device/Actions ───────────────────────────────────────────────
  DEVICE_ACTION_LOCK: {
    requires: ["DEVICE_INVENTORY", "DEVICE_ASSET_OVERVIEW"],
  },
  DEVICE_ACTION_REBOOT: {
    requires: ["DEVICE_INVENTORY", "DEVICE_ASSET_OVERVIEW"],
  },
  DEVICE_ACTION_POWER_OFF: {
    requires: ["DEVICE_INVENTORY", "DEVICE_ASSET_OVERVIEW"],
  },
  DEVICE_ACTION_ENABLE_REMOTE_DESKTOP: {
    requires: ["DEVICE_INVENTORY", "DEVICE_ASSET_OVERVIEW"],
  },
  DEVICE_ACTION_UPDATE_OS: {
    requires: ["DEVICE_INVENTORY", "DEVICE_ASSET_OVERVIEW"],
  },
  DEVICE_ACTION_UN_ENROLL: {
    requires: ["DEVICE_INVENTORY", "DEVICE_ASSET_OVERVIEW"],
  },
  DEVICE_ACTION_LOST_MODE: {
    requires: ["DEVICE_INVENTORY", "DEVICE_ASSET_OVERVIEW"],
  },
  DEVICE_ACTION_WIPE: {
    requires: ["DEVICE_INVENTORY", "DEVICE_ASSET_OVERVIEW"],
  },
  DEVICE_ACTION_SEND_BLANK_PUSH: {
    requires: ["DEVICE_INVENTORY", "DEVICE_ASSET_OVERVIEW"],
  },

  // ─── Device/Maintenance ───────────────────────────────────────────
  DEVICE_MAINTENANCE_LIVE_CONSOLE_ACTION: {
    requires: ["DEVICE_INVENTORY", "DEVICE_MAINTENANCE_LIVE_CONSOLE"],
  },
  DEVICE_MAINTENANCE_LIVE_PROCESSES_ACTION: {
    requires: ["DEVICE_INVENTORY", "DEVICE_MAINTENANCE_LIVE_PROCESSES"],
  },
  DEVICE_MAINTENANCE_LIVE_SERVICE_ACTION: {
    requires: ["DEVICE_INVENTORY", "DEVICE_MAINTENANCE_LIVE_SERVICE"],
  },
  DEVICE_MAINTENANCE_REMOTE_DESKTOP_ACTION: {
    requires: ["DEVICE_INVENTORY", "DEVICE_MAINTENANCE_REMOTE_DESKTOP"],
  },
  DEVICE_MAINTENANCE_RUN_SCRIPT_ACTION: {
    requires: ["DEVICE_INVENTORY", "DEVICE_MAINTENANCE_RUN_SCRIPT"],
  },
  DEVICE_MAINTENANCE_LIVE_MONITORING_ACTION: {
    requires: ["DEVICE_INVENTORY", "DEVICE_MAINTENANCE_LIVE_MONITORING"],
  },

  // ─── Device/Assets sub-actions ────────────────────────────────────
  DEVICE_ASSET_OVERVIEW_ACTION: {
    requires: ["DEVICE_INVENTORY", "DEVICE_ASSET_OVERVIEW"],
  },
  DEVICE_ASSET_OVERVIEW_DELETE: {
    requires: ["DEVICE_INVENTORY", "DEVICE_ASSET_OVERVIEW"],
  },
  DEVICE_ASSET_APPLICATION_ACTION: {
    requires: ["DEVICE_INVENTORY", "DEVICE_ASSET_APPLICATION"],
  },
  DEVICE_ASSET_APPLICATION_DELETE: {
    requires: ["DEVICE_INVENTORY", "DEVICE_ASSET_APPLICATION"],
  },
  DEVICE_ASSET_COMPLIANCE_ACTION: {
    requires: ["DEVICE_INVENTORY", "DEVICE_ASSET_COMPLIANCE"],
  },
  DEVICE_ASSET_COMPLIANCE_DELETE: {
    requires: ["DEVICE_INVENTORY", "DEVICE_ASSET_COMPLIANCE"],
  },
  DEVICE_ASSET_LOCATION_ACTION: {
    requires: ["DEVICE_INVENTORY", "DEVICE_ASSET_LOCATION"],
  },
  DEVICE_ASSET_LOCATION_DELETE: {
    requires: ["DEVICE_INVENTORY", "DEVICE_ASSET_LOCATION"],
  },
  DEVICE_ASSET_PROFILE_DELETE: {
    requires: ["DEVICE_INVENTORY", "DEVICE_ASSET_PROFILE"],
  },
  DEVICE_ASSET_USER_ACTION: {
    requires: ["DEVICE_INVENTORY", "DEVICE_ASSET_USER"],
  },
  DEVICE_ASSET_USER_DELETE: {
    requires: ["DEVICE_INVENTORY", "DEVICE_ASSET_USER"],
  },
  DEVICE_ASSET_NOTE_ACTION: {
    requires: ["DEVICE_INVENTORY", "DEVICE_ASSET_NOTE"],
  },
  DEVICE_ASSET_NOTE_DELETE: {
    requires: ["DEVICE_INVENTORY", "DEVICE_ASSET_NOTE"],
  },

  // ─── Profiles ─────────────────────────────────────────────────────
  SECURITY_PROFILES_EDIT: { requires: ["SECURITY_PROFILES"] },
  SECURITY_PROFILES_ASSIGN: { requires: ["SECURITY_PROFILES"] },
  CONFIGURATION_PROFILES_EDIT: { requires: ["CONFIGURATION_PROFILES"] },
  CONFIGURATION_PROFILES_ASSIGN: { requires: ["CONFIGURATION_PROFILES"] },

  // ─── Software ─────────────────────────────────────────────────────
  SOFTWARE_EDIT: { requires: ["SOFTWARE"] },
  SOFTWARE_ASSIGN: { requires: ["SOFTWARE"] },
  SOFTWARE_DELETE: { requires: ["SOFTWARE"] },

  // ─── Asset Management ─────────────────────────────────────────────
  ASSET_MANAGEMENT_CREATE: { requires: ["ASSET_MANAGEMENT"] },
  ASSET_MANAGEMENT_EDIT: { requires: ["ASSET_MANAGEMENT"] },
  ASSET_MANAGEMENT_DELETE: { requires: ["ASSET_MANAGEMENT"] },

  // ─── Groups ───────────────────────────────────────────────────────
  DEPARTMENTS_EDIT: { requires: ["DEPARTMENTS"] },
  DEPARTMENTS_DELETE: { requires: ["DEPARTMENTS"] },

  // ─── Users ────────────────────────────────────────────────────────
  EMPLOYEES_EDIT: { requires: ["EMPLOYEES"] },
  EMPLOYEES_DELETE: { requires: ["EMPLOYEES"] },
  USER_GROUP_CREATE: { requires: ["USER_GROUP"] },
  USER_GROUP_EDIT: { requires: ["USER_GROUP"] },
  USER_GROUP_DELETE: { requires: ["USER_GROUP"] },

  // ─── Settings ─────────────────────────────────────────────────────
  SETTING_ACL_EDIT: { requires: ["SETTING_ACL"] },
  SETTING_MDM_EDIT: { requires: ["SETTING_MDM"] },
  SETTING_BILLING_EDIT: { requires: ["SETTING_BILLING"] },
  SETTING_SECURITY_EDIT: { requires: ["SETTING_SECURITY"] },
  SETTING_NOTIFICATION_EDIT: { requires: ["SETTING_NOTIFICATION"] },
  SETTING_ORGANIZATION_EDIT: { requires: ["SETTING_ORGANIZATION"] },

  // ─── Dashboard ────────────────────────────────────────────────────
  DASHBOARD_TEMPLATE_EDIT: { requires: ["DASHBOARD_TEMPLATE"] },
  DASHBOARD_TEMPLATE_DELETE: { requires: ["DASHBOARD_TEMPLATE"] },

  // ─── Compliance ───────────────────────────────────────────────────
  COMPLIANCE_EDIT: { requires: ["COMPLIANCE"] },
  COMPLIANCE_DELETE: { requires: ["COMPLIANCE"] },

  // ─── Services/Ticketing ───────────────────────────────────────────
  TICKETING_EDIT: { requires: ["TICKETING"] },
  TICKETING_DELETE: { requires: ["TICKETING"] },

  // ─── Notification: Alert requires Device Inventory ────────────────
  ALERT_NOTIFICATION_CATEGORY: {
    requires: ["DEVICE_INVENTORY", "SOFTWARE"],
  },
};
